
import { Component, Vue } from 'vue-property-decorator'
import { postFetch } from '@/service/common'
import { captchaUrl } from '@/service/url'
import { cryptoEncrypt } from '@/utils/fun'
@Component({})
export default class UserLogin extends Vue {
  form: any = {}
  url = ''
  codeId = 0
  loginLoading = false
  rules: object = {
    username: [
      {
        required: true,
        message: '请输入用户名或手机号',
        trigger: 'change',
      },
    ],
    password: [
      {
        required: true,
        message: '请输入登录密码',
        trigger: 'change',
      },
    ],
    img_code: [
      {
        required: true,
        message: '请输入图片验证码',
        trigger: 'change',
      },
    ],
  }
  created() {
    this.getCodeImage()
  }

  async getCodeImage() {
    const codeId = new Date().getTime() + Math.floor(Math.random() * 1000)
    this.codeId = codeId
    this.url = `${captchaUrl}?code_id=${codeId}`
  }

  handleSubmit() {
    const vm: any = this.$refs.ruleForm
    vm.validate((valid: any) => {
      if (valid) {
        const { password, ...rest } = this.form
        const params = {
          code_id: this.codeId,
          ...rest,
          password: cryptoEncrypt(password),
        }
        this.loginLoading = true
        this.$emit('submit', 'login', params, () => {
          this.getCodeImage()
          this.loginLoading = false
        })
      } else {
        console.log('error submit!!')
        return false
      }
    })
  }
}
